export const DEFAULT_USER_SPACES_PARENT_NAME = 'Default User Spaces';
//# sourceMappingURL=spaces.js.map